export class LocalStorageSaveOptions {
  key: string = '';
  data: any;
  expirationMins?: number;
}
